import type { INotifyByEmailModalForm, TCandidateData } from "@data-display/notifyCandidateModal/types";
import { UploadFileField } from "@inputs/file";
import type { Dispatch, SetStateAction } from "react";
import { type Control, Controller } from "react-hook-form";
import { AttachmentsWithCandidateDocuments } from "./candidateDocuments";

interface IAttachmentsProps {
  control: Control<INotifyByEmailModalForm, void>;
  candidates: readonly TCandidateData[];
  setAttachmentsLoading: Dispatch<SetStateAction<boolean>>;
}

export const Attachments = ({ control, candidates, setAttachmentsLoading }: IAttachmentsProps) => {
  if (candidates.length !== 1) {
    return (
      <Controller
        control={control}
        name="attachments"
        render={({ field: { onChange } }) => (
          <UploadFileField
            onChange={onChange}
            onLoading={setAttachmentsLoading}
            options={{ maxFiles: 5, maxFileSize: 26214400 }}
          />
        )}
      />
    );
  }
  return (
    <AttachmentsWithCandidateDocuments
      control={control}
      candidate={candidates[0]}
      setAttachmentsLoading={setAttachmentsLoading}
    />
  );
};
